module.exports = __webpack_public_path__ + "img/fechapago.7a950709.svg";